import React from "react";

import { FormFieldErrorMessage } from "~/components/form/error-message";
import { FormLabel } from "~/components/form/label";
import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../../_widget";
import { WidgetCalculation } from "../../../widget-form/calculation";
import { WidgetDecimals } from "../../../widget-form/decimals";
import { WidgetFontSize } from "../../../widget-form/font-size";
import { WidgetMetricLabel } from "../../../widget-form/metric-label";
import { WidgetSparkline } from "../../../widget-form/sparkline";
import { FormState } from "../../../widget-form/stat-chart/form-state";
import { WidgetUnit } from "../../../widget-form/unit";
import { SettingsSectionFormField } from "../_field";
import { ResetToDefaultSection } from "../_reset-to-default-section";
import { SettingsSectionGrid } from "../_section-grid";
import { Thresholds } from "../_thresholds";

export interface StatChartProps {
	settings: FormState;
}

export const StatChart: React.FC<StatChartProps> = ({ settings }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<Widget>
			<WidgetHeader className="uppercase" title="Misc">
				<FormFieldReset
					className="ml-auto"
					state={[
						settings.fields.sparkline,
						settings.fields.unit,
						settings.fields.decimals,
						settings.fields.calculation,
						settings.fields.metricLabel,
						settings.fields.fontSize,
					]}
				/>
			</WidgetHeader>

			<WidgetBody card>
				<SettingsSectionGrid className="grid-cols-[auto_1fr]">
					<SettingsSectionFormField layout="horizontal" state={settings.fields.sparkline}>
						<FormLabel>Sparkline</FormLabel>
						<WidgetSparkline name="dashboard-widget-misc-sparkline" sparkline={settings.fields.sparkline} />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.unit}>
						<FormLabel>Unit</FormLabel>
						<WidgetUnit className="w-full" default={undefined} unit={settings.fields.unit} />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.decimals}>
						<FormLabel>Decimals</FormLabel>
						<WidgetDecimals decimals={settings.fields.decimals} name="dashboard-widget-settings-decimal-places" />
						<FormFieldErrorMessage className="col-span-full" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.calculation}>
						<FormLabel>Calculation</FormLabel>
						<WidgetCalculation calculation={settings.fields.calculation} name="dashboard-widget-misc-calculated" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.metricLabel}>
						<FormLabel>Metric Label</FormLabel>
						<WidgetMetricLabel metricLabel={settings.fields.metricLabel} name="dashboard-widget-misc-metric-label" />
					</SettingsSectionFormField>

					<SettingsSectionFormField layout="horizontal" state={settings.fields.fontSize}>
						<FormLabel>Font Size</FormLabel>
						<WidgetFontSize fontSize={settings.fields.fontSize} name="dashboard-widget-misc-value-font-size" />
						<FormFieldErrorMessage className="col-span-full" />
					</SettingsSectionFormField>
				</SettingsSectionGrid>
			</WidgetBody>
		</Widget>

		<div className="flex flex-col gap-4">
			<Widget>
				<WidgetHeader className="uppercase" title="Thresholds">
					<FormFieldReset className="ml-auto" state={[settings.fields.color, settings.fields.thresholds]} />
				</WidgetHeader>

				<WidgetBody card>
					<Thresholds defaultColor={settings.fields.color} thresholds={settings.fields.thresholds} />
				</WidgetBody>
			</Widget>

			<ResetToDefaultSection onClick={() => settings.setInput(FormState.initial)} />
		</div>
	</div>
);
